import * as selectric from "./plugins/selectric.js";
//import * as masonry from "./plugins/masonry.js";

export function init() {
  selectric.init();
  //masonry.init();
}
